<template>
	<div class="summary-dash">
		<mini-weather></mini-weather>
			<mini-nagios></mini-nagios>
		<div class="left-col">
			<mini-clock></mini-clock>
			<mini-traffic></mini-traffic>
		</div>
		<div class="mid-col">
			<div class="logo-mini">
				<div class="logo-container">
					<img src="images/logo-emblem.svg">
				</div>
			</div>
			<mini-ooo></mini-ooo>
		</div>
		<div class="right-col">
			<mini-date></mini-date>
			<mini-map></mini-map>
		</div>
	</div>
</template>

<script>
	import MiniWeather from './weather-mini.vue';
	import MiniNagios from './nagios-mini.vue';
	import MiniClock from './clock-mini.vue';
	import MiniDate from './date-mini.vue';
	import MiniTraffic from './traffic-mini.vue';
	import MiniOoo from './mini-ooo.vue';
	import MiniMap from './map-mini.vue';

	export default {
		name: 'Summary',
		components: {
			MiniWeather,
			MiniNagios,
			MiniClock,
			MiniDate,
			MiniTraffic,
			MiniOoo,
			MiniMap
		},
		destroyed() {
			console.log("Stopping summary dash")
		}
	}
</script>

<style lang="less">
	@import '../../less/_variables.less';

	.summary-dash {
		width: 100%;
		height: 100%;
		display: flex;
		flex-wrap: wrap;

		.left-col {
			width: 40%;
			height: 60%;
			padding: 1% 1% 2% 2%;
		}

		.mid-col {
			width: 20%;
			height: 60%;
			padding: 1% 1% 2%;
		}

		.right-col {
			width: 40%;
			height: 60%;
			padding: 1% 2% 2% 1%;
		}
	}

	.logo-mini {
		height: 55%;
		padding-bottom: 12%;
	
		.logo-container {
			height: 100%;

			img {
				width: 100%;
				height: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// summary-dash.vue?3979889c